(() => {
  const init = () => {
    const bar = document.querySelector('[data-bep-v4-sticky-buy]');
    if (!bar) return;

    const mainButton = document.querySelector('.bep-main-product-premium .product-form__submit');
    const productInfo = document.querySelector('.bep-main-product-premium .product__info-container');
    const stickyButton = bar.querySelector('[data-bep-v4-sticky-submit]');
    const stickyLabel = bar.querySelector('[data-bep-v4-sticky-label]');
    const stickyPrice = bar.querySelector('[data-bep-v4-sticky-price]');
    if (!mainButton || !stickyButton) return;

    let mainButtonVisible = false;
    bar.hidden = false;

    const getPriceNode = () =>
      document.querySelector('.bep-main-product-premium .price__sale .price-item--sale') ||
      document.querySelector('.bep-main-product-premium .price__regular .price-item--regular') ||
      document.querySelector('.bep-main-product-premium .price-item--regular');

    const sync = () => {
      const priceNode = getPriceNode();
      if (priceNode && stickyPrice) stickyPrice.textContent = priceNode.textContent.trim();

      const labelNode = mainButton.querySelector('span:not(.sold-out-message)');
      if (labelNode && stickyLabel) stickyLabel.textContent = labelNode.textContent.trim();

      stickyButton.disabled = Boolean(mainButton.disabled);
    };

    const paint = () => {
      const visible = window.innerWidth < 750 && !mainButtonVisible && window.scrollY > 140;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    stickyButton.addEventListener('click', () => {
      sync();
      if (!mainButton.disabled) mainButton.click();
    });

    document.addEventListener('change', () => window.setTimeout(sync, 80), true);
    window.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint, { passive: true });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        mainButtonVisible = entries.some((entry) => entry.isIntersecting);
        paint();
      }, { threshold: 0.12 });
      observer.observe(mainButton);
    }

    if (productInfo && 'MutationObserver' in window) {
      const mutationObserver = new MutationObserver(() => window.setTimeout(sync, 30));
      mutationObserver.observe(productInfo, { childList: true, subtree: true, attributes: true });
    }

    sync();
    paint();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();